import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { CollectionFile, ComponentFileType, ComponentSection, FileVisibility } from 'models';

import { ComponentChatButton } from 'components/component-chat/components/ComponentChatButton';
import { useComponentChat } from 'components/component-chat/hooks/useComponentChat';
import { ComponentDatasheetSectionProgress } from 'components/component-datasheet/components/ComponentDatasheetSectionProgress';
import { ComponentFilesField } from 'components/component-fields/ComponentFilesField';
import { DatasheetMode, useDatasheetMode } from 'components/datasheet/DatasheetMode';
import { FileGrid } from 'components/files/FileGrid';
import { useCurrentUser } from 'hooks/use-current-user';

import { ComponentDatasheetSection } from './ComponentDatasheetSection';

const Files: FC = () => {
    const user = useCurrentUser();

    const mode = useDatasheetMode();
    const editMode = mode !== DatasheetMode.VIEW;
    const { toggleChatOpen } = useComponentChat();

    const [files = []] = useWatch({ name: ['files'] }) as [CollectionFile[] | undefined];
    const hasFiles = files.length > 0;
    const downloads = files.filter(
        (file) => file.type !== ComponentFileType.CERTIFICATE && file.visibility !== FileVisibility.PRIVATE,
    );

    if (!editMode && downloads.length === 0) return null;

    return (
        <ComponentDatasheetSection
            title="Downloads"
            id={ComponentSection.FILES}
            afterTitle={<ComponentDatasheetSectionProgress section={ComponentSection.FILES} />}
        >
            {user && hasFiles && (
                <ComponentChatButton
                    toggleChatOpen={toggleChatOpen}
                    visibleFrom="sm"
                    style={{
                        pointerEvents: 'all',
                        alignSelf: 'flex-start',
                    }}
                />
            )}
            {editMode ? (
                <ComponentFilesField editable={editMode} />
            ) : (
                downloads.length > 0 && <FileGrid files={downloads} />
            )}
        </ComponentDatasheetSection>
    );
};

export { Files };
